<template>
  <div id="menuSearch" class="flex-center search-box padding-x-10">
    <div class="flex-1 padding-x-10 position-relative padding-y-5 search-wrapper flex-start">
      <img src="@/static/icon-search.png" class="search-icon" />
      <input
        class="search-input margin-left-5 flex-1"
        placeholder="请输入菜单名称"
        v-model="keyWords"
      />
      <div v-if="keyWords" @click="clear" class="clear flex-center padding-3">
        <i class="el-icon-close font-14 color-333"></i>
      </div>
    </div>
  </div>
</template>
<script >
import { inject } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const {
    keyWords,
    setKeyWords
  } = inject('keyWords', {});
  const clear = () => {
    setKeyWords('');
  };
  return {
    keyWords,
    clear
  };
};
export default __sfc_main;
</script>
<style scoped lang="scss">
  $width: 360px;
  $leftWidth: 130px;
  .search-box {
    position: absolute;
    top: 0;
    height: 60px;
    left: $leftWidth;
    right: 0;
    background-color: #fff;
    border-radius: 16px 0 0 0;
  }
  .search-wrapper {
    background: #f3f3f3;
    border-radius: 20px;
  }
  .search-icon {
    width: 14px;
    height: 14px;
  }
  .search-input {
    border-radius: 10px;
    border: none;
    outline: none;
    color: #333;
    font-size: 14px;
    background-color: transparent;
    &::placeholder {
      font-size: 12px;
      color: #999;
    }
  }
  .clear {
    cursor: pointer;
    border-radius: 50%;
    transition: all 0.2s;
    &:hover {
      transform: rotate(180deg);
      background-color: #fff;
    }
  }
</style>
